export function subFundListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow: true,
    searchLabelWidth:120,
    index: true,
    indexLabel: "序号",
    indexWidth:50,
    refreshBtn: true,
    // selection: true,
    // selectionWidth: 45,
    column: [

      {
        label: "子基金名称",
        prop: "fundName",
        search: true,
        slot: true,


      },
      {
        label: '批次',
        prop: 'createTime',
        type: 'datetime',
        format: "yyyy-MM",
        valueFormat: "yyyy-MM",
        width: 120,
        slot:true

      },
      // {
      //   label: "审核状态",
      //   prop: "auditState",
      //   type: "select",
      //   search: true,
      //   dataType: 'number',
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   display: false,
      //   overHidden: true,
      //   width: 100,

      // },
      {
        label: "填报情况",
        prop: "auditState",
        type: "select",
        search: true,
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=report_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        display: false,
        overHidden: true,
        width: 100,

      },
      {
        label: "投后报告周期",
        prop: 'manageCycle',
        // search: true,
        type: 'select',
        dataType: 'string',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: "120"
      },

      {
        label: '生成时间',
        prop: 'submitTime',
        type: 'datetime',
        format: "yyyy-MM-dd hh:mm",
        valueFormat: "yyyy-MM-dd hh:mm",
        width: 160,

      },

      // {
      //   label: '变更次数',
      //   prop: 'changeNumber',
      //   width: 70,
      //   formatter: (row, value, label, column) => {
      //     return value>0?`第${value}次 `:'';
      //   },
      // },
      // {
      //   label: '变更原因',
      //   prop: 'modifiedReason',

      // },
      // {
      //   label: '审核提交时间',
      //   prop: 'auditBeginTime',
      //   width: 100,

      // },

      
      {
        label: '提交时间',
        prop: 'auditTime',
        type: 'datetime',
        format: "yyyy-MM-dd HH:mm:ss",
        valueFormat: "yyyy-MM-dd HH:mm:ss",
        width: 120,

      },











    ]
  }
}


export function subFundAddConfig(changeThirdParty) {
  return {
    labelWidth: 140,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: "基金名称",
        prop: "name",
        span: 12,
        // overHidden: true,
        disabled: true,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }],
      },
      {
        label: "出资主体",
        prop: "masterName",
        span: 12,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        formslot: true,
        disabled: true,
      },
      {
        label: '基金类型',
        // prop: 'fundType',
        prop:'isDirectional',
        type: "select",
        span: 12,
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=subFund_type",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        disabled: true,

      },

      // {
      //   label: '基金大类',
      //   prop: 'fundAllType',
      //   type: "select",
      //   span: 12,
      //   dataType: 'number',
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=fund_target_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   rules: [{
      //     required: true,
      //     message: "请输入内容",
      //     trigger: "change",
      //   }, ],
      //   disabled: false,
      // },
      {
        label: "合作方式",
        prop: "cooperateType",
        type: "select",
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=cooperate_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        disabled: true
      },
      {
        label: "认缴金额",
          prop: "peScale",
          // prop:'govIndustrySubscribed',
        span: 12,
        append: '元',
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        disabled: true
      },
      {
        label: "实缴金额",
        prop: "totalCapitalPaid",
        // prop:'realGovIndustrySubscribed',
        span: 12,
        append: '元',
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "change",
        }, ],
        disabled: true
      },
      {
        label: "基金管理人",
           // prop: "fundManagerName",
           prop:"fdManagerName",
        span: 12,
        // overHidden: true,
        // placeholder:"等待生成基金管理人",
        formslot: true,
        disabled: true,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      },
      {
        label: '报告周期',
        prop: 'manageCycle',
        span: 12,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
        disabled: true,
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },
        dataType: 'number',
        rules: [{
          required: true,
          message: '请选择报告周期',
          trigger: "change",
        }, ]
      },
      {
        label: "估值办法",
        prop: "valuationMethod",
        display: false,
        span: 12,
        disabled: false,
      },


      {
        label: "基金到期日",
        prop: "fundDueDate",
        format: 'yyyy-MM-dd',
        valueFormat: "yyyy-MM-dd",
        type: "date",
        span: 12,
        disabled: false,
        display: false
      },
      {
        label: "基金成立日",
        prop: "establishmentDate",
        format: 'yyyy-MM-dd',
        valueFormat: "yyyy-MM-dd",
        type: "date",
        span: 12,
        disabled: false,
        display: false
      },

      {
        label: "退出期",
        prop: "quitDate1",
        type: "daterange",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        startPlaceholder: "开始",
        endPlaceholder: "结束",
        span: 12,
        disabled: false,
        display: false

      },
      {
        label: "投资期",
        prop: "investDate1",
        type: "daterange",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        startPlaceholder: "开始",
        endPlaceholder: "结束",
        span: 12,
        disabled: false,
        display: false

      },
      // {
      //   label: "清算期",
      //   prop: "clearingDate1",
      //   type: "daterange",
      //   format: "yyyy-MM-dd",
      //   valueFormat: "yyyy-MM-dd",
      //   startPlaceholder: "开始",
      //   endPlaceholder: "结束",
      //   span: 12,
      //   disabled: false,
      //   display: false
      //   // formslot:true
      // },
      {
        label: "金投股权认缴金额",
        prop: "govCapitalSubscribed",
        span: 12,
        append: '元',
        // rules: [{
        //   required: true,
        //   message: "请输入内容",
        //   trigger: "change",
        // }, ],
        disabled: false,
        display: false
      },
      {
        label: "金投股权实缴金额",
        prop: "govCapitalPaid",
        display: false,
        span: 12,
        append: '元',
        // rules: [{
        //   required: true,
        //   message: "请输入内容",
        //   trigger: "change",
        // }, ],
        disabled: false
      },
      {
        label: "执行事务合伙人",
        prop: "executivePartner",
        display: false,
        span: 12,
        disabled: false,

      },
      {
        label: "普通合伙人",
        prop: "generalPartner",
        display: false,
        span: 12,
        disabled: false,

      },
      {
        label: "基金编码",
        prop: "number",
        display: false,
        span: 12,
        disabled: false,
      },
      {
        label: '基金注册地',
        prop: 'address',
        formslot: true,
        span: 12,
        disabled: false,
        display: false,
      },
      // {
      //   label: "基金联系人",
      //   prop: "",
      //   display: false,
      //   span: 12,
      //   disabled: false,
      // },
      // {
      //   label: "基金联系方式",
      //   prop: "",
      //   display: false,
      //   span: 12,
      //   disabled: false,
      // },


      {
        label: "基金经理及联系方式",
        prop: "fundManagerDetail",
        display: false,
        span: 12,
        disabled: false,
      },
      {

        label: '投资目标',
        prop: 'investObjective',
        span: 24,
        display: false,
        type: 'textarea',
        disabled: false,
      },
      {

        label: '投资策略',
        prop: 'investStrategy',
        span: 24,
        display: false,
        type: 'textarea',
        disabled: false,
      },
      {

        label: '投资范围',
        prop: 'investScope',
        span: 24,
        display: false,
        type: 'textarea',
        disabled: false,
      },
      {

        label: '关注行业',
        prop: 'concernIndustry',
        span: 24,
        display: false,
        type: 'textarea',
        disabled: false,
      },
      {

        label: '关注阶段',
        prop: 'concernStage',
        span: 24,
        display: false,
        type: 'textarea',
        disabled: false,
      },
      {

        label: '其他需说明事项',
        prop: 'explainMatter',
        span: 24,
        display: false,
        type: 'textarea',
        disabled: false,
      }

    ]
  }
}